import { createContext, useContext } from 'react';

import { openUntrustedUrl } from '@/utils/external-links';

type SaveEdits = () => Promise<boolean>;

// How a link in a card opens: the host card routes its own "Open in ‹app›" link through the server, after
// `saveEdits` saves what the user typed. Outside a card, a link opens as it is
export type CardOpen = (url: string, saveEdits?: SaveEdits) => void;

export const CardOpenContext = createContext<CardOpen>((url) =>
  openUntrustedUrl(url)
);

export const useCardOpen = (): CardOpen => useContext(CardOpenContext);

// The card's save of its unsaved edits, for chrome the host draws on the card rather than its document, such as the
// open Feed card's header and the meeting among its band's sources. Outside a card there is nothing to save
const nothingToSave: SaveEdits = async () => true;

export const CardSaveEditsContext = createContext<SaveEdits>(nothingToSave);

export const useCardSaveEdits = (): SaveEdits =>
  useContext(CardSaveEditsContext);
